import { render, staticRenderFns } from "./VeracruzReservaUti.vue?vue&type=template&id=04edc4d3&scoped=true"
import script from "./VeracruzReservaUti.vue?vue&type=script&lang=ts"
export * from "./VeracruzReservaUti.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04edc4d3",
  null
  
)

export default component.exports